import { render, staticRenderFns } from "./RecordDetails.vue?vue&type=template&id=42d6d43b"
import script from "./RecordDetails.vue?vue&type=script&lang=js"
export * from "./RecordDetails.vue?vue&type=script&lang=js"
import style0 from "./RecordDetails.vue?vue&type=style&index=0&id=42d6d43b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports